module.exports = __webpack_public_path__ + "static/img/about_img.6d22898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_img.jpg
// module id = iz5Q
// module chunks = 0